module.exports = __webpack_public_path__ + "img/webText.e1c49fbd.jpg";